// extracted by mini-css-extract-plugin
export var square = "styles-module--square--a8341";
export var square1 = "styles-module--square1--813e8";
export var square2 = "styles-module--square2--20ea1";
export var square3 = "styles-module--square3--a9d33";